import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import { useCookies } from '@magalu/mixer-utils';
import ShareLinksProduct from '../ShareLinksProduct';
import ShareLinksActions from '../ShareLinksActions';
import { EventLinkType } from '../../constants';
import { Description, Title } from '../../ShareLinks.styles';
import Tabs from '../Tabs';
import useShareActionsTabsContent from '../../hooks/useShareActionsTabsContent';
var ShareLinksModalContent = function ShareLinksModalContent(_ref) {
  var data = _ref.data,
    structure = _ref.structure,
    staticProps = _ref.staticProps,
    oneLink = _ref.oneLink,
    magaly = _ref.magaly,
    isOpen = _ref.isOpen;
  var _useCookies = useCookies(),
    toggleRemovePromoterOfferTabs = _useCookies.toggleRemovePromoterOfferTabs;
  var tabs = useShareActionsTabsContent({
    data: data,
    isOpen: isOpen,
    magaly: magaly,
    oneLink: oneLink,
    staticProps: staticProps,
    structure: structure
  });
  if (toggleRemovePromoterOfferTabs) {
    return React.createElement(React.Fragment, null, React.createElement(Title, {
      as: "h3",
      fontSize: 5,
      fontWeight: "bold",
      paddingTop: 1,
      color: "text.base"
    }, "Compartilhe e ganhe!"), React.createElement(Description, {
      as: "p",
      fontSize: 3,
      fontWeight: "bold",
      color: "Description.dark"
    }, "Copie seu link e compartilhe com seus clientes, com ele voc\xEA garante sua comiss\xE3o seja no app ou site do Magalu."), React.createElement(ShareLinksProduct, {
      data: data,
      device: structure.device || 'desktop'
    }), React.createElement(ShareLinksActions, {
      data: data,
      linkType: EventLinkType.APP_MAGALU,
      shortenLink: oneLink.shortenLink,
      urlToCopy: oneLink.urlToCopy,
      structure: structure,
      staticProps: staticProps
    }));
  }
  return React.createElement(React.Fragment, null, React.createElement(Title, {
    as: "h3",
    fontSize: 5,
    fontWeight: "bold",
    paddingBottom: 4,
    paddingTop: 1,
    color: "text.base"
  }, "Gerar link afiliado"), React.createElement(Description, {
    as: "p",
    fontSize: 3,
    fontWeight: "bold",
    color: "Description.dark",
    lineHeight: 2,
    paddingY: 2
  }, "Escolha a forma de compartilhar seu link de afiliado e envie para seu p\xFAblico."), React.createElement(Tabs, {
    tabs: tabs
  }));
};
process.env.NODE_ENV !== "production" ? ShareLinksModalContent.propTypes = {
  data: shape({
    product: shape({
      image: string,
      title: string
    })
  }),
  isOpen: Boolean.isRequired,
  magaly: shape({}).isRequired,
  oneLink: shape({}).isRequired,
  staticProps: shape({
    device: string,
    sectionSharedBag: shape({
      buttonLabel: string,
      show: string,
      url: string
    }),
    sectionSocial: shape({
      buttons: arrayOf(shape({
        color: string,
        eventType: string,
        href: string,
        name: string
      })),
      title: string
    })
  }).isRequired,
  structure: shape({})
} : void 0;
ShareLinksModalContent.defaultProps = {
  data: {},
  structure: {}
};
export default ShareLinksModalContent;